<template>
  <form @submit.prevent="submitHandler">

    <div class="alert alert-danger text-center" v-if="errMsg">
      {{ errMsg }}
    </div>

    <div class="form-group row">
      <label class="col-sm-4 col-form-label col-form-label-sm">{{$t("Old password")}}:</label>
      <div class="col-sm-8">
        <input type="password"
          class="form-control form-control-sm"
          :class="[{ 'is-invalid': !$v.formData.oldPassword.required && $v.formData.oldPassword.$dirty }]"
          @blur="$v.formData.oldPassword.$touch()"
          v-model="formData.oldPassword">
        <div class="invalid-feedback">
          {{$t("Please, enter old password")}}.
        </div>
      </div>
    </div>

    <div class="form-group row">
      <label class="col-sm-4 col-form-label col-form-label-sm">{{$t("New Password")}}:</label>
      <div class="col-sm-8">
        <input type="password"
          class="form-control form-control-sm"
          :class="[{ 'is-invalid': !$v.formData.newPassword.required && $v.formData.newPassword.$dirty }]"
          @blur="$v.formData.newPassword.$touch()"
          v-model="formData.newPassword">
        <div class="invalid-feedback">{{$t("Please, enter the new password")}}</div>
      </div>
    </div>

    <div class="form-group row">
      <label class="col-sm-4 col-form-label col-form-label-sm">{{$t("Repeat New Password")}}:</label>
      <div class="col-sm-8">
        <input type="password"
          class="form-control form-control-sm"
          :class="[{ 'is-invalid': (!$v.formData.repNewPassword.required && $v.formData.repNewPassword.$dirty) || !$v.formData.repNewPassword.sameAsNewPass }]"
          @blur="$v.formData.repNewPassword.$touch()"
          v-model="formData.repNewPassword">
        <div class="invalid-feedback">
          {{ $v.formData.repNewPassword.sameAsNewPass ? $t("Repeated password is not the same") : $t("Please, repeat the password") }}
        </div>
      </div>
    </div>

    <button type="submit" class="btn btn-lg btn-block btn-success" :disabled="$v.formData.$invalid">{{$t("Change Password")}}</button>

    <loading :loading="loading"></loading>

  </form>
</template>


<script>
import { required, sameAs } from 'vuelidate/lib/validators'
import usersService from '../../services/userService'

export default {
  props: {
    csrfToken: {},
  },
  validations: {
    formData: {
      oldPassword: {
        required,
      },
      newPassword: {
        required,
      },
      repNewPassword: {
        required,
        sameAsNewPass: sameAs('newPassword'),
      },
    },
  },
  data() {
    return {
      formData: {
        oldPassword: null,
        newPassword: null,
        repNewPassword: null,
      },
      loading: false,
      errMsg: null,
    }
  },
  methods: {
    submitHandler() {
      if (!this.$v.formData.$invalid) {
        this.loading = true
        usersService.changePass(this.formData.oldPassword, this.formData.newPassword)
          .then(res => {
            this.$emit('changeSuccess')
          })
          .catch(() => {
            // TODO: provide a better error message
            this.errMsg = 'OOPSS! Something goes wrong. Try again.'
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/-client-app/components/forms/ChangePasswordForm.vue